<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="900px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">print</v-icon>
            <span class="px-3">{{ $t(`Balance Sheet`) }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea" style="padding-top: 10px">
        <invoice-header class="only-for-print" />
        <v-layout column>
          <v-layout row wrap class="invoice-content">
            <v-flex xs12 style="text-align: center" class="only-for-print" pb-2>
              <strong>{{ $t('Balance Sheet') }}</strong>
            </v-flex>
            <v-flex xs12>
              <table style="width: 100%" class="income-statement-border" id="exported-table" cellspacing="0">
                <tbody>
                  <tr class="statement-titles">
                    <td class="bottom-border" colspan="2">
                      {{ $t('Assets') }}
                    </td>
                  </tr>
                  <tr class="statement-subtitle">
                    <td class="bottom-border" colspan="2">
                      {{ $t('Cash') }}
                    </td>
                  </tr>
                  <tr v-for="(r, index) in responseData.cash" :key="100 + index">
                    <td class="bottom-border">{{ r.account_chart_name.trim() }}</td>
                    <td class="bottom-border">{{ r.balance | currency }}</td>
                  </tr>
                  <!--                  <tr class="statement-subtitle">-->
                  <!--                    <td class="bottom-border" colspan="2">-->
                  <!--                      {{ $t('Current Asset') }}-->
                  <!--                    </td>-->
                  <!--                  </tr>-->
                  <!--                  <tr v-for="(r, index) in responseData.current_asset" :key="200 + index">-->
                  <!--                    <td class="bottom-border">{{ r.account_chart_name.trim() }}</td>-->
                  <!--                    <td class="bottom-border">{{ r.balance | currency }}</td>-->
                  <!--                  </tr>-->
                  <tr class="statement-subtitle">
                    <td class="bottom-border" colspan="2">
                      {{ $t('Fixed Asset') }}
                    </td>
                  </tr>
                  <tr v-for="(r, index) in responseData.fixed_asset" :key="300 + index">
                    <td class="bottom-border">{{ r.account_chart_name.trim() }}</td>
                    <td class="bottom-border">{{ r.balance | currency }}</td>
                  </tr>
                  <tr class="statement-subtitle">
                    <td class="bottom-border">{{ $t('Total Assets') }}</td>
                    <td class="bottom-border">
                      {{ responseData.assets_total | currency }}
                    </td>
                  </tr>

                  <tr class="statement-titles">
                    <td class="bottom-border" colspan="2">
                      {{ $t('Liabilities and Owner Equities') }}
                    </td>
                  </tr>
                  <tr class="statement-subtitle">
                    <td class="bottom-border" colspan="2">
                      {{ $t('Equity') }}
                    </td>
                  </tr>
                  <tr v-for="(r, index) in responseData.equity" :key="400 + index">
                    <td class="bottom-border">{{ r.account_chart_name.trim() }}</td>
                    <td class="bottom-border">{{ r.balance | currency }}</td>
                  </tr>
                  <tr class="statement-subtitle">
                    <td class="bottom-border">{{ $t('Total Equity') }}</td>
                    <td class="bottom-border">
                      {{ responseData.equity_total | currency }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-layout>
        <invoice-footer
          :showSignatureSection="false"
          :accountantName="''"
          :payerRecipientName="''"
          :payerOrRecipient="''"
          class="only-for-print"
        />
      </v-card-title>

      <v-footer style="border-top: 1px solid lightgrey" class="print-export-dialog-footer global-not-printable">
        <v-spacer></v-spacer>
        <v-btn outline color="primary" @click="$emit('hidemodal')">
          {{ $t('Close') }}
        </v-btn>

        <v-btn v-if="clickedButton === 'print'" color="primary" @click="printMe()">
          <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
          {{ $t('Print') }}
        </v-btn>

        <v-btn v-if="clickedButton === 'export'" color="primary" @click="exportTable()">
          <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">fa-file-excel</v-icon>
          {{ $t('Export') }}
        </v-btn>
      </v-footer>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import XLSX from 'xlsx'
import ignored from 'print-this'

export default {
  name: 'view-component',

  props: {
    viewDialog: { type: Boolean, required: true },
    responseData: { type: Object, required: true },
    clickedButton: { type: String, required: true }
  },

  components: {
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      viewInfo: 'fixedAssets/getFixedAssetInfo',
      settings: 'configurations/getSystemSettings'
    })
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      helpers.doPrinting()
    },

    exportTable() {
      this.showHeaderSpace = false
      setTimeout(() => {
        var tbl = document.getElementById('exported-table')
        var ws = XLSX.utils.table_to_sheet(tbl)

        // this is to export json to excel
        // var ws = XLSX.utils.json_to_sheet(this.resultData.data)
        // var wscols = [{ width: 'auto' }, { width: 'auto' }] // this line and the line below is to
        // set the width for exported column
        // ws['!cols'] = wscols

        var wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
        XLSX.writeFile(wb, `Income Statement.xlsx`)
        this.showHeaderSpace = true
      }, 500)
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
.income-statement-border {
  border: 1px solid gray;
}
.statement-titles {
  border-bottom: 1px solid gray;
  background-color: gray;
  color: white;
  -webkit-print-color-adjust: exact;
  font-size: 18px;
  font-weight: bold;
  height: 36px;
  padding-left: 10px;
}
.statement-subtitle {
  border-bottom: 1px solid gray;
  background-color: lightgray;
  -webkit-print-color-adjust: exact;
  font-size: 16px;
  font-weight: bold;
  height: 34px;
  padding-left: 10px;
}
.bottom-border {
  border-bottom: 1px solid gray;
  width: 50%;
  height: 34px;
  padding-left: 10px;
}
.top-border {
  background-color: lightgray;
  -webkit-print-color-adjust: exact;
  border-top: 1px solid gray;
  font-weight: bold;
  height: 34px;
  padding-left: 10px;
}
.first-subtotal {
  background-color: lightgray;
  -webkit-print-color-adjust: exact;
  font-weight: bold;
  height: 34px;
  padding-left: 10px;
}
</style>
